<div *ngIf="inTransitList as inTransit else loading">
  <p-toolbar styleClass="">
    <ng-template pTemplate="left">
    </ng-template>

    <ng-template pTemplate="right">
      <p-button icon="pi pi-undo" label="Сбросить фильтр" styleClass="p-button-success mr-2" (onClick)="clearOrResetTableFilter($event)"
                pTooltip="Сбросить фильтр и вернуться в начало" tooltipPosition="top"></p-button>

      <p-button label="XLSX" icon="pi pi-file-excel" styleClass="p-button-info mr-2" (onClick)="onExportData()"
                pTooltip="Экспортировать информацию о товарах" tooltipPosition="top" [disabled]="!totalRecords"></p-button>
    </ng-template>
  </p-toolbar>

  <p-table #inTransitTable [value]="inTransit"
           [totalRecords]="totalRecords"
           [paginator]="true"
           [rows]="rows"
           [showCurrentPageReport]="true"
           [rowsPerPageOptions]="[10,20,50,100]"
           currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} товаров"
           selectionMode="single"
           [(selection)]="selectedRow"
           dataKey="PRODID"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped"
           [resizableColumns]="true"
           columnResizeMode="fit"
           filterDelay="200"
           rowExpandMode="single"
           sortField="DOCEXPDATE">

    <ng-template pTemplate="caption">
      <div class="grid align-items-center">
        <div class="col-2">
          <h5>Счета за {{monthToLoad}} месяцев: </h5>
        </div>
        <div class="col-2">
          <p-slider [(ngModel)]="monthToLoad" [min]="6" [max]="36" [step]="6" (onSlideEnd)="onSlideEnd($event)"></p-slider>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem"></th>
        <th pResizableColumn pSortableColumn="PRODCODE" style="width: 15%">Код <p-sortIcon field="PRODCODE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="PRODWAITQNTY" style="width: 8rem">В транзите <p-sortIcon field="PRODWAITQNTY"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMQTY" style="width: 8rem">Заказано <p-sortIcon field="DOCITEMQTY"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCEXPDATE" style="width: 10%">Отгрузка <p-sortIcon field="DOCEXPDATE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCVALDATE" style="width: 10%">Ожидается <p-sortIcon field="DOCVALDATE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCNAMESTR" style="width: 10%">Документ <p-sortIcon field="DOCNAMESTR"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCDATE" style="width: 10%">Дата <p-sortIcon field="DOCDATE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="VENDORNAME" style="width: 10%">Поставщик <p-sortIcon field="VENDORNAME"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="LOCALCOMP" style="width: 10%">Получатель <p-sortIcon field="LOCALCOMP"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCNOTE1" style="width: 15%">Примечание получателя <p-sortIcon field="DOCNOTE1"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCNOTE2" style="width: 15%">Примечание поставщика <p-sortIcon field="DOCNOTE2"></p-sortIcon></th>
      </tr>

      <tr>
        <th style="width: 3rem"></th>
        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск по коду" class="p-dropdown-filter-style"
                   [(ngModel)]="cf1" (input)="inTransitTable.filter($event.target.value, 'PRODCODE', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="number" placeholder="Поиск..." class="p-dropdown-filter-style"
                   [(ngModel)]="cf2" (input)="inTransitTable.filter($event.target.value, 'PRODWAITQNTY', 'gtOrZero')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="number" placeholder="Поиск..." class="p-dropdown-filter-style"
                   [(ngModel)]="cf3" (input)="inTransitTable.filter($event.target.value, 'DOCITEMQTY', 'gtOrZero')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск" class="p-dropdown-filter-style"
                   [(ngModel)]="cf4" (input)="inTransitTable.filter($event.target.value, 'DOCVALDATE', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск" class="p-dropdown-filter-style"
                   [(ngModel)]="cf5" (input)="inTransitTable.filter($event.target.value, 'DOCEXPDATE', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск по номеру" class="p-dropdown-filter-style"
                   [(ngModel)]="cf6" (input)="inTransitTable.filter($event.target.value, 'DOCNAMESTR', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск" class="p-dropdown-filter-style"
                   [(ngModel)]="cf7" (input)="inTransitTable.filter($event.target.value, 'DOCDATE', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск" class="p-dropdown-filter-style"
                   [(ngModel)]="cf8" (input)="inTransitTable.filter($event.target.value, 'VENDORNAME', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск" class="p-dropdown-filter-style"
                   [(ngModel)]="cf9" (input)="inTransitTable.filter($event.target.value, 'LOCALCOMP', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск" class="p-dropdown-filter-style"
                   [(ngModel)]="cf10" (input)="inTransitTable.filter($event.target.value, 'DOCNOTE1', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск" class="p-dropdown-filter-style"
                   [(ngModel)]="cf11" (input)="inTransitTable.filter($event.target.value, 'DOCNOTE2', 'contains')">
          </div>
        </th>

      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-prod let-expanded="expanded">
      <tr [pSelectableRow]="prod">

        <td style="width: 3rem">
          <button type="button" pButton pRipple
                  [pRowToggler]="prod" class="p-button-text p-button-rounded p-button-plain"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
          </button>
        </td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"><a [routerLink]="['/edit-product', prod.PRODID]">{{prod.PRODCODE}}</a></td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right">{{prod.PRODWAITQNTY | number:'1.0-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right">{{prod.DOCITEMQTY | number:'1.0-2' }}</td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{prod.DOCVALDATE  | date:'dd.MM.yyyy'}}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{prod.DOCEXPDATE  | date:'dd.MM.yyyy'}}</td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><a [routerLink]="['/edit-document', 10, prod.DOCID]">{{prod.DOCNAMESTR}}</a></td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{prod.DOCDATE  | date:'dd.MM.yyyy'}}</td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{prod.VENDORNAME}}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{prod.LOCALCOMP}}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{prod.DOCNOTE1}}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{prod.DOCNOTE2}}</td>

      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-prod>
      <tr>
        <td colspan="12">
          <div class="p-p-1">
            <app-product-reservation-table [prodId]="prod.PRODID"></app-product-reservation-table>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="12">Нет данных для загрузки</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #loading>
  <p>Информация о товарах загружается...</p>
</ng-template>
